import { appendLog } from './scanLogQueue';

export async function saveLogToStorage(logData) {
  await appendLog(logData);
}
